const pt = {
  brand: "E2 Care",
  tagline: "Cuidados calmos e conectados.",
  nav_dashboard: "Painel",
  nav_residents: "Pacientes",
  nav_patients: "Pacientes",
  nav_rooms: "Quartos",
  nav_devices: "Dispositivos",
  nav_events: "Eventos",
  nav_alerts: "Alertas",
  nav_users: "Equipa",
  nav_settings: "Definições",
  nav_admin: "Administração",
  nav_signout: "Sair",
  topbar_search_placeholder: "Pesquisar pacientes, quartos, dispositivos…",
  admin_super_only: "Apenas superadministradores podem gerir organizações.",
  admin_admin_only: "Apenas administradores podem aceder a esta página.",
  admin_tab_orgs: "Organizações",
  admin_tab_users: "Utilizadores",
  admin_tab_patients: "Pacientes",
  admin_tab_rooms: "Quartos",
  admin_tab_buildings: "Edifícios",
  admin_tab_devices: "Dispositivos",
  admin_tab_alerts: "Alertas",
  admin_tab_qa: "Ferramentas de teste",
  admin_delete: "Eliminar",
  admin_no_orgs_yet: "Ainda não há organizações.",
  admin_field_name: "Nome",
  admin_field_email: "E-mail",
  admin_field_phone: "Telefone",
  admin_field_password: "Palavra-passe",
  admin_field_role: "Função",
  admin_field_type: "Tipo",
  admin_field_timezone: "Fuso horário",
  admin_field_address: "Morada",
  admin_field_status: "Estado",
  admin_field_organization: "Organização",
  admin_password_keep: "Deixe em branco para manter",
  admin_field_birth_date: "Data de nascimento",
  admin_field_room: "Quarto",
  admin_field_room_none: "Não atribuído",
  admin_field_photo: "URL da foto",
  admin_field_photo_hint: "Cole um URL público — upload completo na v2.",
  admin_field_notes: "Notas do cuidador",
  admin_field_emergency_contact: "Contacto de emergência principal",
  admin_field_ec_name: "Nome",
  admin_field_ec_phone: "Telefone",
  admin_field_ec_relationship: "Relação",
  admin_field_mac: "Endereço MAC",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Atribuído a",
  admin_field_assigned_room: "Quarto atribuído",
  admin_field_assigned_patient: "Paciente atribuído",
  admin_field_assigned_hint: "Opcional. Sensores → quarto; pulseiras → paciente.",
  admin_field_sensor_target: "Montado em",
  admin_field_sensor_target_hint: "Indica ao sistema se este sensor vigia uma porta ou uma janela.",
  sensor_target_door: "Porta",
  sensor_target_window: "Janela",
  sensor_target_unset: "Não configurado",
  admin_field_sensor_label: "Etiqueta do sensor",
  admin_field_sensor_label_hint: "Nome amigável mostrado em alertas e eventos — p. ex. «Porta da frente», «Janela da casa de banho».",
  admin_field_building: "Edifício",
  admin_field_building_required: "Um quarto deve pertencer a um edifício.",
  room_openings: "Aberturas",
  room_no_openings: "Ainda não há sensores de porta ou janela instalados neste quarto.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Última alteração",
  admin_field_description: "Descrição",
  admin_field_severity: "Gravidade",
  admin_field_patient: "Paciente",
  admin_field_device: "Dispositivo",
  admin_field_message: "Mensagem",
  admin_orgs_title: "Organizações",
  admin_orgs_sub: "Criar, editar e arquivar inquilinos do E2 Care.",
  admin_orgs_count: "organizações",
  admin_org_new: "Nova organização",
  admin_org_new_title: "Nova organização",
  admin_org_edit_title: "Editar organização",
  admin_org_created: "Organização criada.",
  admin_org_updated: "Organização atualizada.",
  admin_org_deleted: "Organização arquivada.",
  admin_org_delete_title: "Arquivar organização?",
  admin_org_delete_confirm: "«{name}» será ocultada das listas.",
  admin_users_title: "Utilizadores",
  admin_users_sub_super: "Gerir todas as contas de utilizador em todos os inquilinos.",
  admin_users_sub_org: "Gerir contas de utilizador de {org}.",
  admin_user_new: "Novo utilizador",
  admin_user_new_title: "Novo utilizador",
  admin_user_edit_title: "Editar utilizador",
  admin_user_created: "Utilizador criado.",
  admin_user_updated: "Utilizador atualizado.",
  admin_user_deleted: "Utilizador arquivado.",
  admin_user_delete_title: "Arquivar utilizador?",
  admin_user_delete_confirm: "«{name}» perderá o acesso.",
  admin_user_memberships: "Pertenças a organizações",
  admin_patients_title: "Pacientes",
  admin_patients_sub_super: "Gerir todos os pacientes em todos os inquilinos.",
  admin_patients_sub_org: "Gerir pacientes em {org}.",
  admin_patient_new: "Novo paciente",
  admin_patient_new_title: "Novo paciente",
  admin_patient_edit_title: "Editar paciente",
  admin_patient_created: "Paciente criado.",
  admin_patient_updated: "Paciente atualizado.",
  admin_patient_deleted: "Paciente arquivado.",
  admin_patient_delete_title: "Arquivar paciente?",
  admin_patient_delete_confirm: "«{name}» será ocultado das listas.",
  admin_rooms_title: "Quartos",
  admin_rooms_sub_super: "Configurar quartos em todos os inquilinos.",
  admin_rooms_sub_org: "Configurar quartos em {org}.",
  admin_room_new: "Novo quarto",
  admin_room_new_title: "Novo quarto",
  admin_room_edit_title: "Editar quarto",
  admin_room_created: "Quarto criado.",
  admin_room_updated: "Quarto atualizado.",
  admin_room_deleted: "Quarto arquivado.",
  admin_room_delete_title: "Arquivar quarto?",
  admin_room_delete_confirm: "«{name}» será ocultado.",
  admin_devices_title: "Dispositivos",
  admin_devices_sub_super: "Aprovisionar dispositivos Moko em todos os inquilinos.",
  admin_devices_sub_org: "Aprovisionar dispositivos Moko em {org}.",
  admin_device_new: "Novo dispositivo",
  admin_device_new_title: "Novo dispositivo",
  admin_device_edit_title: "Editar dispositivo",
  admin_device_created: "Dispositivo criado.",
  admin_device_updated: "Dispositivo atualizado.",
  admin_device_deleted: "Dispositivo arquivado.",
  admin_device_delete_title: "Arquivar dispositivo?",
  admin_device_delete_confirm: "O dispositivo {mac} será ocultado.",
  admin_buildings_title: "Edifícios",
  admin_buildings_sub_super: "Agrupar quartos por edifício / ala em todos os inquilinos.",
  admin_buildings_sub_org: "Agrupar quartos por edifício / ala em {org}.",
  admin_building_new: "Novo edifício",
  admin_building_new_title: "Novo edifício",
  admin_building_edit_title: "Editar edifício",
  admin_building_created: "Edifício criado.",
  admin_building_updated: "Edifício atualizado.",
  admin_building_deleted: "Edifício arquivado.",
  admin_building_delete_title: "Arquivar edifício?",
  admin_building_delete_confirm: "«{name}» será ocultado.",
  admin_qa_title: "Ferramentas de teste",
  admin_qa_sub: "Injete eventos / alertas para testar sem hardware Moko real.",
  admin_qa_event_title: "Injetar evento de teste",
  admin_qa_event_sub: "Simula um webhook do Moko.",
  admin_qa_alert_title: "Injetar alerta de teste",
  admin_qa_alert_sub: "Salta a camada de eventos e escreve um alerta diretamente.",
  admin_qa_inject_event: "Injetar evento",
  admin_qa_inject_alert: "Injetar alerta",
  admin_qa_event_done: "Evento injetado.",
  admin_qa_alert_done: "Alerta injetado.",
  admin_qa_disclaimer: "Estes endpoints devem estar desativados em produção.",
  admin_alerts_title: "Política de alertas",
  admin_alerts_sub: "Regras de alerta para toda a {org}. Aplicadas a cada paciente deste inquilino.",
  admin_alerts_quiet_title: "Horas de silêncio",
  admin_alerts_quiet_desc: "Defina quando esta organização está em «modo noturno». Útil para encaminhar alertas não críticos de forma mais discreta.",
  admin_alerts_quiet_hint: "As horas são interpretadas no fuso horário local da organização. O intervalo pode passar da meia-noite (p. ex. 22:00 → 06:00).",
  admin_alerts_night_start: "A noite começa",
  admin_alerts_night_end: "A noite termina",
  admin_alerts_load_failed: "Carregar política de alertas",
  admin_alerts_save_failed: "Guardar política de alertas",
  admin_alerts_saved: "Política de alertas guardada.",
  admin_alerts_clear_title: "Limpar alertas ativos",
  admin_alerts_clear_desc: "Confirme todos os alertas abertos desta organização com um clique.",
  admin_alerts_clear_hint: "Útil após um exercício planeado ou um sensor mal configurado que produziu uma onda de falsos positivos. Os alertas confirmados permanecem no histórico.",
  admin_alerts_ack_all_button: "Confirmar todos",
  admin_alerts_ack_all_title: "Confirmar todos os alertas ativos?",
  admin_alerts_ack_all_confirm: "Isto marcará como confirmado cada alerta aberto em {org}. Esta ação não pode ser anulada.",
  admin_alerts_ack_all_done: "{count} alerta(s) confirmado(s).",
  admin_alerts_ack_all_done_generic: "Todos os alertas ativos confirmados.",
  admin_alerts_ack_all_failed: "Confirmar todos os alertas",
  org_type_nursing_home: "Lar de idosos",
  org_type_assisted_living: "Residência assistida",
  org_type_hospital: "Hospital",
  org_type_home_care: "Cuidados domiciliários",
  role_admin: "Administrador",
  role_caregiver: "Cuidador",
  role_family: "Família",
  status_active: "ativo",
  status_inactive: "inativo",
  confirm: "Confirmar",
  sign_in: "Iniciar sessão",
  signed_in: "Sessão iniciada",
  sign_up: "Registar",
  email: "E-mail",
  password: "Palavra-passe",
  full_name: "Nome completo",
  create_account: "Criar conta",
  no_account: "Ainda não tem conta?",
  have_account: "Já tem uma conta?",
  login_welcome: "Bem-vindo de volta",
  login_sub: "Inicie sessão para continuar a monitorizar os seus residentes.",
  register_welcome: "Junte-se à E2 Care",
  register_sub: "Crie o seu espaço de trabalho em menos de um minuto.",
  total_residents: "Pacientes",
  active_devices: "Dispositivos ativos",
  open_alerts: "Alertas abertos",
  offline_gateways: "Dispositivos offline",
  falls_7d: "Quedas (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Bateria fraca",
  critical_residents: "Críticos",
  status_ok: "Tudo bem",
  status_warning: "Atenção",
  status_critical: "Crítico",
  status_online: "Online",
  status_offline: "Offline",
  search: "Pesquisar",
  filter: "Filtrar",
  all: "Todos",
  refresh: "Atualizar",
  loading: "A carregar…",
  no_results: "Ainda nada aqui.",
  view_profile: "Ver perfil",
  showing_n_of_m: "A mostrar {n} de {m}",
  load_more: "Carregar mais",
  auto_refresh: "Ao vivo · atualização automática",
  auto_refresh_paused: "Em pausa (carregar mais ativo)",
  updated_just_now: "Atualizado agora",
  updated_n_sec_ago: "Atualizado há {n}s",
  updated_n_min_ago: "Atualizado há {n}m",
  acknowledge: "Confirmar",
  acknowledged: "Confirmado",
  ack_all: "Confirmar todos",
  ack_all_confirm: "Confirmar os {count} alerta(s) ativo(s)?",
  ack_all_running: "A confirmar…",
  ack_all_done: "{count} alerta(s) confirmado(s).",
  ack_all_partial: "{ok} confirmado(s) · {fail} falhado(s).",
  last_seen: "Visto pela última vez",
  battery: "Bateria",
  signal: "Sinal",
  firmware: "Firmware",
  room: "Apt. / Quarto",
  age: "Idade",
  emergency_contact: "Contacto de emergência",
  notes: "Notas",
  assigned_devices: "Dispositivos atribuídos",
  recent_events: "Eventos recentes",
  timeline_24h: "Últimas 24 horas",
  delivery_status: "Estado de entrega",
  acknowledged_by: "Confirmado por",
  dashboard_title: "Visão geral",
  dashboard_sub: "Uma leitura rápida de tudo o que acontece nos lares que cuida.",
  residents_title: "Pacientes",
  residents_sub: "Pessoas que está a monitorizar agora.",
  devices_title: "Dispositivos",
  devices_sub: "Sensores e pulseiras.",
  devices_sub_admin: "Gateways, sensores e pulseiras.",
  events_title: "Eventos ao vivo",
  events_sub: "Fluxo cronológico de cada dispositivo conectado.",
  alerts_title: "Alertas",
  alerts_sub: "Notificações encaminhadas para família e cuidadores.",
  settings_title: "Definições",
  settings_sub: "As suas preferências e regras de notificação.",
  users_title: "Equipa",
  users_sub: "Cuidadores, família e administradores com acesso.",
  falls_chart_title: "Quedas e SOS — últimos 7 dias",
  recent_alerts_title: "Alertas críticos recentes",
  no_alerts: "Sem alertas abertos. Todos estão em segurança.",
  event_fall: "Queda detetada",
  event_sos: "Botão SOS premido",
  event_door_open: "Porta aberta",
  event_door_close: "Porta fechada",
  event_inactivity: "Inatividade prolongada",
  event_low_battery: "Bateria fraca",
  event_offline: "Dispositivo offline",
  event_online: "Dispositivo novamente online",
  event_heartbeat: "Batimento",
  event_button_press: "Botão premido",
  device_gateway: "Gateway Bluetooth",
  device_door_sensor: "Sensor de porta",
  device_bracelet: "Pulseira",
  device_unknown: "Dispositivo desconhecido",
  language: "Idioma",
  notifications: "Notificações",
  quiet_hours: "Horas silenciosas",
  escalation: "Política de escalonamento",
  just_now: "agora mesmo",
  rel_prefix: "há",
  min_ago: "min",
  h_ago: "h",
  d_ago: "d",
  demo_hint: "Conta demo: admin@e2care.lv / Care2024!",
  open_menu: "Abrir menu",
  close_menu: "Fechar menu",
  care_team: "Equipa de cuidados",
  family_members: "Família",
  no_caregivers: "Sem cuidadores atribuídos.",
  no_family: "Sem familiares ligados.",
  add_caregiver: "Adicionar cuidador",
  add_family: "Adicionar familiar",
  select_user: "Selecione um utilizador…",
  cancel: "Cancelar",
  add: "Adicionar",
  remove: "Remover",
  save: "Guardar",
  relationship: "Parentesco",
  relationship_son: "Filho",
  relationship_daughter: "Filha",
  relationship_spouse: "Cônjuge",
  relationship_other: "Outro",
  notify_via: "Notificar via",
  call_contact: "Ligar",
  view_resident: "Abrir perfil",
  address: "Morada",
  admin_only_section: "Ferramentas de admin",
  rooms_title: "Quartos",
  rooms_sub: "Todos os quartos que supervisiona — pacientes, dispositivos e estado atual.",
  room_name: "Quarto",
  room_type: "Tipo",
  room_type_private_room: "Quarto privado",
  room_type_shared_room: "Quarto partilhado",
  room_type_apartment: "Apartamento",
  room_type_corridor: "Corredor",
  room_type_common_area: "Área comum",
  room_floor: "Piso",
  room_state: "Estado atual",
  door: "Porta",
  window: "Janela",
  door_open_state: "Aberta",
  door_closed_state: "Fechada",
  door_unknown_state: "Desconhecido",
  room_no_devices: "Ainda sem dispositivos neste quarto.",
  room_no_patients: "Ainda sem pacientes atribuídos a este quarto.",
  room_patients: "Pacientes no quarto",
  room_devices: "Dispositivos no quarto",
  room_activity: "Cronologia de atividade",
  rooms_filter_all_types: "Todos os tipos",
  widget_active_alerts: "Alertas ativos",
  widget_active_alerts_sub: "Críticos, não resolvidos e confirmados",
  widget_patients_status: "Estado dos pacientes",
  widget_devices_health: "Saúde dos dispositivos",
  widget_room_activity: "Atividade dos quartos",
  widget_recent_events: "Feed de eventos ao vivo",
  widget_connectivity: "Conectividade",
  metric_critical: "Crítico",
  metric_unresolved: "Não resolvido",
  metric_acknowledged_count: "Confirmados",
  metric_total: "Total",
  metric_active: "Ativos",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "OTA pendente",
  metric_battery_warn: "Bateria fraca",
  metric_doors_open: "Portas abertas",
  metric_windows_open: "Janelas abertas",
  metric_signal_avg: "Sinal médio",
  metric_last_comm: "Última com.",
  metric_packets: "Pacotes / h",
  view_all: "Ver tudo",
  status_new: "Novo",
  status_acknowledged: "Confirmado",
  status_resolved: "Resolvido",
  status_resolved_local: "Resolvido (local)",
  resolve: "Resolver",
  add_note: "Adicionar nota",
  save_note: "Guardar nota",
  resolve_local_badge: "apenas este dispositivo",
  resolve_local_hint: "Marca o alerta como resolvido apenas no seu navegador. O servidor e os outros membros da equipa continuam a vê-lo como aberto.",
  note_placeholder: "Adicione contexto para a equipa…",
  notes_count: "{n} nota(s)",
  device_detail: "Detalhe do dispositivo",
  device_diagnostics: "Diagnóstico",
  device_firmware_history: "Histórico de firmware",
  device_ota_config: "Configuração OTA",
  device_ota_status: "Estado OTA",
  device_signal: "Qualidade do sinal",
  device_mac: "Endereço MAC",
  device_serial: "Número de série",
  fall_sensitivity: "Sensibilidade a quedas",
  transmission_interval: "Intervalo de transmissão",
  low_battery_threshold: "Limite de bateria fraca",
  ota_idle: "Inativo",
  ota_pending: "Pendente",
  ota_deploying: "A implementar",
  ota_failed: "Falhou",
  events_filter_severity: "Gravidade",
  events_filter_room: "Quarto",
  events_filter_patient: "Paciente",
  events_filter_device: "Dispositivo",
  severity_info: "Info",
  severity_warning: "Aviso",
  severity_critical: "Crítico",
  telegram_title: "Alertas do Telegram",
  telegram_desc: "Receba alertas no Telegram para os residentes que lhe foram atribuídos.",
  telegram_connect: "Ligar Telegram",
  telegram_connected: "Telegram ligado",
  telegram_connected_as: "Ligado ao Telegram como {name}",
  telegram_connect_success: "Telegram ligado com sucesso",
  telegram_connect_error: "Não foi possível ligar o Telegram. Tente novamente.",
  telegram_missing_bot: "Bot do Telegram não configurado. Defina REACT_APP_TELEGRAM_BOT no ficheiro env.",
  telegram_disconnect: "Desligar",
  telegram_disconnect_success: "Telegram desligado.",
  telegram_disconnect_error: "Não foi possível desligar o Telegram. Tente novamente.",
  telegram_already_linked: "Esta conta do Telegram já está associada a outro utilizador e2-care.",
  telegram_switch_q: "Usar outra conta do Telegram?",
  telegram_switch_intro: "O Telegram lembra-se de qual conta está autenticada em todos os sites. Para usar outra:",
  telegram_switch_step1: "Abra o Telegram Web e termine a sessão da sua conta atual.",
  telegram_switch_step2: "Volte aqui e recarregue o botão abaixo, depois inicie sessão com a outra conta.",
  telegram_open_web: "Abrir Telegram Web",
  telegram_reload_widget: "Terminei a sessão — recarregar o botão",
  lang_autodetected_toast: "Idioma detetado: {language}. Pode alterá-lo nas Definições.",
  admin_view_active: "Ativos",
  admin_view_archived: "Arquivados",
  admin_restore: "Restaurar",
  admin_restored: "Restaurado.",
  admin_hard_delete: "Eliminar permanentemente",
  admin_hard_delete_title: "Eliminar permanentemente?",
  admin_hard_delete_confirm: "«{name}» será removido permanentemente da base de dados. Esta ação não pode ser anulada.",
  admin_hard_deleted: "Eliminado permanentemente.",
  admin_no_archived: "Sem elementos arquivados.",
  language_desc: "Usada para a interface da aplicação e para as suas notificações Telegram + push.",
  language_saved: "Idioma atualizado.",
  language_error: "Não foi possível atualizar o idioma. Tente novamente.",
  admin_field_language: "Idioma",
  edit: "Editar",
  generic_error: "Algo correu mal. Tente novamente.",
  caregiver_added: "Cuidador adicionado.",
  caregiver_removed: "Cuidador removido.",
  family_added: "Familiar adicionado.",
  family_removed: "Familiar removido.",
  menu: "Menu",
  dl_companion_app: "Aplicação complementar",
  dl_hero_title: "E2 Care para Android",
  dl_hero_sub: "Instale a aplicação complementar num telefone equipado com Moko para retransmitir alertas, configurar dispositivos e manter-se ligado à sua equipa de cuidados — mesmo quando o painel está fechado.",
  dl_android_apk: "APK Android",
  dl_version_loading: "a carregar versão…",
  dl_released: "Lançado a {date}",
  dl_download_apk: "Transferir APK",
  dl_unavailable: "Indisponível",
  dl_preparing: "A preparar…",
  dl_manifest_error: "Não foi possível carregar o manifesto. Tente atualizar; se o problema persistir, o servidor de compilação pode estar a ser reimplementado.",
  dl_whats_new: "Novidades",
  dl_installing_title: "Instalação no seu telefone",
  dl_step1: "Toque em «Transferir APK» acima. O seu navegador pode avisar que os ficheiros APK podem danificar o dispositivo — esse aviso é normal para qualquer instalador transferido fora da Play Store.",
  dl_step2: "Abra o ficheiro transferido. O Android irá pedir-lhe para permitir instalações a partir deste navegador na primeira vez — ative a permissão e volte.",
  dl_step3: "Toque em «Instalar» e depois em «Abrir» quando terminar.",
  dl_step4: "Inicie sessão com as suas credenciais E2 Care.",
  dl_iphone_note: "A versão para iPhone chegará mais tarde. Por agora, use o painel web.",
  dl_back_to_dashboard: "Voltar ao painel",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Alterar a organização limpa a atribuição atual de quarto e paciente.",
  admin_view_full: "Lista completa",
  device_filter_assignment: "Atribuição",
  device_filter_patient: "Atribuído a paciente",
  device_filter_room: "Atribuído a quarto",
  device_filter_unassigned: "Não atribuído",
  admin_all_orgs: "Todas as organizações",
  pagination_prev: "Anterior",
  pagination_next: "Seguinte",
  pagination_per_page: "Por página",
  pagination_page_of: "Página {page} de {pages}",
  pagination_total: "{total} no total",
  event_charging: "Carregamento iniciado",
  event_sos_cancel: "SOS cancelado",
  event_call: "Chamada SOS",
  device_personal_alarm: "Alarme pessoal",
  device_charging: "A carregar",
  device_location: "Localização",
  device_current_location: "Localização atual",
  device_no_location: "Ainda sem localização reportada.",
  device_location_source: "Fonte",
  device_location_updated: "Atualizado",
  device_track_1h: "1h",
  device_track_24h: "24h",
  device_track_7d: "7d",
  device_track_last: "Última posição",
  device_located: "Localizado",
  map_sos: "Alerta SOS",
  map_fall: "Queda detetada",
  map_current: "Posição atual",
  alert_timeline: "Cronologia do alerta",
  alert_trigger: "Acionador",
  alert_calls: "Chamadas",
  alert_view_timeline: "Ver cronologia",
  alert_no_deliveries: "Ainda não foram enviadas notificações.",
  alert_cancelled_on_device: "O SOS foi cancelado no dispositivo — o alerta permanece aberto até que um cuidador o resolva.",
  call_answered: "Atendida",
  call_missed: "Perdida",
  reopen: "Reabrir",
  reopened: "Alerta reaberto",
  live: "Ao vivo",
  nav_home: "Início",
  family_home_kicker: "Vista de família",
  family_home_title: "Os seus entes queridos",
  family_greeting: "Olá",
  family_home_sub: "Uma visão tranquila de como está cada um.",
  family_status_ok: "está bem",
  family_status_attention: "precisa de atenção",
  family_all_calm: "Tudo calmo neste momento.",
  family_attention_sub: "Vamos ver como está — detalhes abaixo.",
  family_last_seen: "visto pela última vez",
  family_latest_alert: "Último alerta",
  family_no_alerts: "Sem alertas recentes — está tudo bem.",
  family_view_details: "Ver detalhes",
  family_no_device: "Ainda não há alarme pessoal associado.",
  status_never_reported: "Nunca reportou",
  mv_title: "Movimento",
  mv_sub: "De {n} sensor(es) de movimento · janelas de 5 minutos",
  mvo_title: "Movimento num relance",
  mvs_moving: "{name} está de pé e em movimento",
  mvs_moving_sub: "Mexeu-se {when}",
  mvs_rest: "{name} está a descansar",
  mvs_rest_sub: "Último movimento {when}",
  mvs_rest_sub_none: "Sem movimento nos últimos 30 dias",
  mvs_quiet: "{name} está sem se mexer há mais tempo do que o habitual",
  mvs_quiet_sub: "Sem movimento há {dur}. Talvez valha a pena ligar.",
  mvs_short_quiet: "Parado há muito",
  mvs_room_moving: "Alguém se está a mexer em {name}",
  mvs_room_rest: "{name} está calmo",
  mvs_room_quiet: "Sem movimento em {name} há mais tempo do que o habitual",
  mvs_sensor: "O sensor de movimento não está a enviar",
  mvs_sensor_sub: "Isto é sobre o sensor, não sobre {name}. Último sinal {when}.",
  mvs_nodata: "Ainda sem dados de movimento",
  mvs_nodata_sub: "O sensor de movimento ainda não enviou nada.",
  mvd_title: "Últimas 24 horas",
  mvd_moving: "Em movimento",
  mvd_resting: "Em repouso",
  mvd_nosignal: "Sem sinal",
  mvd_night: "Noite",
  mvd_now: "Agora",
  mvn_title: "Últimas 7 noites",
  mvn_last_night: "Ontem à noite",
  mvn_last_short: "Ontem",
  mvn_calm: "Calma",
  mvn_restless: "Agitada",
  mvn_still: "Muito parada",
  mvn_silent: "Sensor calado",
  mvn_nodata: "Sem dados",
  mvn_s_calm_none: "Noite calma, sem movimento entre as {from} e as {to}.",
  mvn_s_calm_once: "Noite calma, levantou-se uma vez por volta das {at}.",
  mvn_s_calm_many: "Noite calma, levantou-se {n} vezes, a primeira por volta das {first}, a última por volta das {last}.",
  mvn_s_restless: "Noite agitada, levantou-se {n} vezes entre as {first} e as {last}.",
  mvn_s_still: "Noite muito parada, menos movimento do que o habitual. Descanso mais longo {dur}.",
  mvn_s_still_moved: "Noite muito parada, só se mexeu por volta das {at}. Descanso mais longo {dur}.",
  mvn_s_silent: "O sensor esteve quase calado, por isso não sabemos como correu a noite.",
  mvn_s_nodata: "Sem dados de movimento para esta noite.",
  mv_state_moving: "Em movimento",
  mv_state_still: "Em repouso",
  mv_state_inactive: "Inativo",
  mv_state_silent: "Sensor sem reportar",
  mv_state_never: "Nunca reportou",
  mv_state_nodata: "Ainda sem dados",
  mv_state_no_sensor: "Sem sensor de movimento",
  mv_last_movement: "Último movimento",
  mv_last_sample: "Último sinal do sensor",
  mv_none_in_retention: "Nenhum nos últimos 30 dias",
  mv_silent_hint: "Sem amostras há mais de {min} min: verifique o sensor ou o seu gateway. É uma falha do dispositivo, não imobilidade.",
  mv_inactive_hint: "Sem movimento há mais de {min} min enquanto o sensor continua a reportar.",
  mv_history: "Histórico de movimento",
  mv_history_empty: "Ainda não há dados de movimento neste período.",
  mv_not_reporting: "Sem reportar",
  mv_no_movement: "Sem movimento",
  mv_detections: "deteções de movimento",
  mv_legend_motion: "Deteções de movimento",
  mv_legend_gap: "Sem reportar",
  mv_retention_note: "Histórico guardado 30 dias",
  mv_strip_title: "Movimento ao vivo",
  mv_strip_sub: "{n} sensor(es) de movimento",
  mv_unassigned: "Sensor não atribuído",
  admin_alerts_timezone: "Fuso horário da organização",
  admin_alerts_timezone_invalid: "Escolha um fuso horário IANA válido.",
  admin_alerts_night_wrap_hint: "O horário noturno vai das {start} às {end} da manhã seguinte ({tz}), ou seja, depois das {start} ou antes das {end}.",
  admin_alerts_night_same_day_hint: "O horário noturno vai das {start} às {end} no mesmo dia ({tz}).",
  admin_alerts_night_equal: "O início e o fim não podem ser iguais.",
  admin_alerts_inactivity_label: "Limite de inatividade",
  admin_alerts_inactivity_question: "Esta pessoa mexeu-se? Minutos sem movimento antes de se tornar motivo de alerta.",
  admin_alerts_silence_label: "Limite de silêncio do dispositivo",
  admin_alerts_silence_question: "Este sensor ainda comunica? Minutos sem qualquer amostra antes de ser considerado uma falha do dispositivo e não um residente inativo.",
  admin_alerts_minutes: "minutos",
  admin_alerts_threshold_invalid: "Introduza um número inteiro maior que 0.",
  admin_alerts_thresholds_provisional: "Os valores iniciais (180 / 30 min) ainda não foram afinados: ajuste-os aos seus residentes.",
  admin_tab_gateways: "Gateways",
  gw_title: "Gateways",
  gw_status_deactivated: "Desativado",
  gw_scope_pending: "Os gateways da sua organização aparecerão aqui quando a atualização do backend estiver ativa.",
  gw_none_for_org: "Ainda não há gateways atribuídos a esta organização.",
  gw_col_room: "Quarto",
  gw_unassigned: "Não atribuído",
  gw_never: "Nunca",
  gw_edit_title: "Editar gateway",
  gw_new_title: "Novo gateway",
  gw_super_field: "Só um super-admin pode alterar isto",
  gw_mac_invalid: "Introduza 12 caracteres hexadecimais, ex. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Tipo de hardware",
  gw_notes: "Notas",
  gw_manage_sub: "Hubs BLE que retransmitem os sensores: estado, organização e quarto. Um gateway calado faz parecer calados todos os sensores atrás dele.",
  gw_filter_all: "Todas as organizações",
  gw_new: "Novo gateway",
  gw_col_assignment: "Organização · Quarto",
  gw_backend_pending: "Isto requer a atualização do backend, ainda não implementada.",
  gw_save_failed: "Guardar gateway",
  gw_created: "Gateway criado",
  gw_saved: "Gateway guardado",
  gw_reactivated: "Gateway reativado",
  gw_deactivated: "Gateway desativado",
  gw_reactivate: "Reativar",
  gw_deactivate: "Desativar",
  gw_reactivate_title: "Reativar {name}?",
  gw_deactivate_title: "Desativar {name}?",
  gw_reactivate_desc: "Voltará a contar no estado e nos alertas.",
  gw_deactivate_desc: "Deixa de contar no estado e nos alertas. O histórico é mantido e pode reativá-lo a qualquer momento.",
  gw_heard_title: "Dispositivos que ouve",
  gw_heard_sub: "Sensores retransmitidos por este gateway nas últimas 24 horas.",
  gw_heard_none: "Nenhum dispositivo nas últimas 24 horas.",
  gw_heard_unknown: "Dispositivos desconhecidos",
  gw_msgs_short: "msg",
  gw_avg: "média",
  gw_samples_short: "amostras",
  gw_not_found: "Gateway não encontrado ou não visível.",
  gw_one: "Gateway",
  gw_manage_link: "Gerir em Administração",
  gw_rssi_range: "Intervalo de sinal",
  gw_longest_gap: "Maior interrupção",
  gw_config_push: "Último envio de config.",
  gw_sub: "Hubs BLE que retransmitem os dados dos sensores. Só de leitura: um gateway em silêncio faz parecer silenciosos todos os sensores ligados.",
  gw_super_only: "O estado dos gateways está disponível apenas para super-administradores.",
  gw_load_failed: "Carregar gateways",
  gw_status_reporting: "A reportar",
  gw_status_silent: "Em silêncio",
  gw_status_never_seen: "Nunca visto",
  gw_returned: "Voltou após {h} h de ausência (terminou {at})",
  gw_count_reporting: "{n} a reportar",
  gw_count_silent: "{n} em silêncio",
  gw_count_never: "{n} nunca vistos",
  gw_count_deactivated: "{n} desativado(s)",
  gw_window: "Desatualizado após {h} h sem mensagens",
  gw_col_name: "Gateway",
  gw_col_status: "Estado",
  gw_col_msgs: "Mensagens 24 h",
  gw_col_discard: "Descartadas",
  gw_last_message: "Última mensagem",
  gw_devices_seen: "Dispositivos vistos",
  gw_hours_active: "Horas ativas",
  gw_unregistered_title: "A reportar sem registo",
  gw_unregistered_desc: "Estes identificadores aparecem na atividade dos gateways mas não têm registo (p. ex. uma unidade que reporta com um IMEI). É normal que os totais das duas fontes sejam diferentes.",
  nav_reports: "Relatórios",
  rep_night_title: "Resumo noturno",
  rep_night_desc: "Resumo matinal do movimento de cada residente durante o horário noturno da organização e dos silêncios dos sensores.",
  rep_last_night: "Ontem à noite",
  rep_nights_ago: "Há {n} noites",
  rep_policy_fallback: "horário noturno predefinido (política indisponível)",
  rep_movement: "Movimento",
  rep_windows: "{n} janelas de 5 min ativas",
  rep_no_movement: "Sem movimento",
  rep_first_movement: "Primeiro movimento",
  rep_longest_still: "Maior período imóvel",
  rep_silences: "Silêncios do sensor",
  rep_none: "Nenhum",
  rep_coverage: "{pct}% reportado",
  rep_night_note: "As horas estão no fuso da organização. A imobilidade só é contada enquanto o sensor reporta; silêncios iguais ou superiores ao limite de silêncio são listados à parte.",
  dh_reporting_title: "Estado de comunicação",
  dh_never_reported_desc: "Registado mas nunca reportou. É uma instalação incompleta, não um dispositivo offline.",
  dh_interval_still: "Intervalo medido (parado)",
  dh_interval_moving: "Intervalo medido (em movimento)",
  dh_interval_samples: "Amostras de medição",
  dh_interval_unmeasured: "Ainda sem intervalo medido: aplica-se o limite de silêncio da organização.",
  dh_interval_note: "Os intervalos são medidos a partir das mensagens recebidas, não do valor configurado.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Quarto partilhado — pode incluir o movimento de outros",
  rep_no_data_night: "Sem dados para esta noite — o sensor não reportava (ou ainda não estava instalado).",
  nav_buildings: "Edifícios",
  imei_label: "IMEI",
  imei_hint: "15 dígitos, impressos na parte de trás do dispositivo",
  imei_length: "O IMEI tem 15 dígitos",
  imei_invalid: "Este IMEI não é válido. Verifique os dígitos",
  imei_resident_note: "O alarme acompanha o residente, por isso não é atribuído a um quarto.",
  imei_online_hint: "O dispositivo aparece online após o primeiro sinal de vida, cerca de 5 minutos depois de ligado.",
  forgot_link: "Esqueceu a palavra-passe? Clique aqui",
  forgot_title: "Repor a palavra-passe",
  forgot_sub: "Introduza o seu email e enviaremos um link para repor a palavra-passe.",
  forgot_submit: "Enviar link",
  forgot_sent: "Se existir uma conta com este email, enviámos um link para repor a palavra-passe. Verifique a sua caixa de entrada.",
  forgot_back: "← Voltar ao início de sessão",
  reset_title: "Definir nova palavra-passe",
  reset_sub: "Escolha uma nova palavra-passe para a sua conta.",
  reset_new_password: "Nova palavra-passe",
  reset_confirm_password: "Confirmar palavra-passe",
  reset_hint: "Pelo menos 8 caracteres.",
  reset_submit: "Atualizar palavra-passe",
  reset_success: "Palavra-passe atualizada. A redirecionar para o início de sessão…",
  reset_too_short: "A palavra-passe deve ter pelo menos 8 caracteres.",
  reset_mismatch: "As palavras-passe não coincidem.",
  reset_no_token: "Este link é inválido ou está em falta. Peça um novo na página de início de sessão.",
  reset_failed: "Este link é inválido ou expirou. Peça um novo.",
  admin_tab_device_types: "Tipos de dispositivo",
  admin_dt_title: "Tipos de dispositivo",
  admin_dt_sub: "O catálogo de modelos. Mude a etiqueta visível de um tipo — a chave interna, o mapeamento IoT e a sincronização não mudam.",
  admin_dt_col_label: "Etiqueta visível",
  admin_dt_col_key: "Chave interna",
  admin_dt_col_category: "Categoria",
  admin_dt_col_wearable: "Portátil",
  admin_dt_col_ble_sync: "Sincronização BLE",
  admin_dt_col_ble_type_id: "ID de tipo BLE",
  admin_dt_wearable_yes: "Usado pelo residente",
  admin_dt_wearable_no: "Fixo",
  admin_dt_ble_sync_on: "Obrigatória",
  admin_dt_ble_sync_off: "Desligada",
  admin_dt_edit_label: "Editar etiqueta",
  admin_dt_edit_title: "Mudar etiqueta",
  admin_dt_edit_desc: "Só muda a etiqueta legível. Dispositivos, filtros e integrações continuam a usar a chave interna «{key}».",
  admin_dt_label_saved: "Etiqueta atualizada.",
  admin_dt_label_required: "A etiqueta não pode estar vazia.",
  admin_dt_load_failed: "Carregar tipos de dispositivo",
  admin_dt_save_failed: "Atualizar etiqueta",
  admin_dt_readonly_hint: "Só os super-administradores podem mudar etiquetas.",
  sensor_climate: "Clima",
  sensor_temperature: "Temperatura",
  sensor_humidity: "Humidade",
  sensor_last_reading: "Última leitura",
  sensor_history_title: "Temperatura e humidade (48 h)",
  sensor_history_empty_title: "Ainda sem leituras",
  sensor_history_empty_sub: "Atribua um sensor H4 Pro a este quarto para ver o histórico climático.",
  admin_thresholds_title: "Limites dos sensores",
  admin_thresholds_desc: "Limites de alerta de temperatura e humidade para os sensores H4 Pro desta organização.",
  admin_thresholds_temp_min: "Temperatura mín.",
  admin_thresholds_temp_max: "Temperatura máx.",
  admin_thresholds_hum_min: "Humidade mín.",
  admin_thresholds_hum_max: "Humidade máx.",
  admin_thresholds_temp_invalid: "A temperatura mínima deve ser inferior à máxima.",
  admin_thresholds_hum_invalid: "A humidade mínima deve ser inferior à máxima.",
  admin_thresholds_hint: "Os quatro são opcionais — deixe um campo vazio para não alertar nesse limite.",
  admin_thresholds_cooldown: "Intervalo entre alertas",
  admin_thresholds_cooldown_placeholder: "Predefinição: 30 min",
  admin_thresholds_cooldown_help: "Minutos entre alertas repetidos do sensor. Deixe vazio para o valor do sistema (30 min).",
  admin_thresholds_cooldown_invalid: "O intervalo deve ser um número inteiro de pelo menos 1 minuto.",
  admin_thresholds_saved: "Limites guardados.",
  admin_thresholds_load_failed: "Carregar limites",
  admin_thresholds_save_failed: "Guardar limites",
  room_activity_view_all: "Ver todos os eventos",
  role_super_admin: "Super-administrador",
  assign_device: "Atribuir dispositivo",
  select_device: "Selecione um dispositivo…",
  admin_patient_no_devices_assigned: "Nenhum dispositivo atribuído.",
  admin_patient_no_wearables: "Não há dispositivos portáteis disponíveis nesta organização.",
  admin_patient_device_reassign: "reatribuir",
  recent_critical_alerts_title: "Alertas críticos recentes",
  rooms_building_clear: "Limpar filtro",
  buildings_title: "Edifícios",
  buildings_sub: "Todos os edifícios que supervisiona, com quartos, residentes e dispositivos.",
  buildings_view_rooms: "Ver quartos",
  wt_title: "Tendência semanal",
  wt_desc: "Sete noites lado a lado por residente — ou por quarto partilhado — para detetar noites agitadas ou invulgarmente paradas.",
  wt_baseline_note: "cada noite é comparada com a mediana de 7 noites da linha",
  wt_no_sensors: "Nenhum residente tem ainda sensor de movimento.",
  wt_flag_restless: "Agitada",
  wt_flag_still: "Invulgarmente parada",
  wt_flag_nodata: "Sem dados",
  wt_flag_silent: "Sensor quase sem sinal",
  rep_sensor_silent: "O sensor só reportou durante {pct}% desta noite. As falhas significam que o sensor deixou de reportar, não que o residente estivesse imóvel.",
  wt_legend_active: "Janelas de 5 min ativas",
  wt_legend_still: "Maior período imóvel (h)",
  fap_title: "Os familiares podem tratar alertas",
  fap_desc: "Se ativo, os familiares podem confirmar, resolver, reabrir e anotar os alertas dos seus próprios residentes em {org}.",
  note_saved: "Nota guardada",
  event_device_silent: "Sensor sem sinal",
  event_no_movement: "Sem movimento",
  event_no_rise: "Sem movimento após a noite",

  dur_lt_min: "menos de um minuto",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Queda detetada",
  am_sos: "Botão SOS pressionado",
  am_low_battery: "Bateria do dispositivo fraca",
  am_low_battery_dev: "Bateria fraca em {device}",
  am_door: "Porta aberta",
  am_door_in: "Porta aberta em {place}",
  am_door_in_detail: "Porta aberta em {place} ({detail})",
  am_window: "Janela aberta",
  am_window_in: "Janela aberta em {place}",
  am_window_in_detail: "Janela aberta em {place} ({detail})",
  am_silent: "O sensor de movimento em {place} deixou de comunicar há cerca de {dur} — verifique a alimentação ou o gateway",
  am_silent_nodur: "O sensor de movimento em {place} deixou de comunicar — verifique a alimentação ou o gateway",
  am_nomove: "Nenhum movimento detetado em {place} há cerca de {dur}",
  am_nomove_nodur: "Nenhum movimento detetado em {place}",
  am_norise: "Nenhum movimento detetado em {place} desde o fim da noite (normalmente levantado às {time})",
  am_norise_notime: "Nenhum movimento detetado em {place} desde o fim da noite",
  amf_silent_res: "O sensor de movimento de {name} não comunica desde as {time}, por isso o movimento não está a ser acompanhado de momento.",
  amf_silent_room: "O sensor de movimento em {place} não comunica desde as {time}, por isso o movimento não está a ser acompanhado ali de momento.",
  amf_sensor_ok: "O sensor está a funcionar; simplesmente não viu ninguém mexer-se.",
  amf_team: "A equipa de cuidados foi alertada no seu painel.",
  amf_contact_device: "É o contacto indicado para este dispositivo.",
  amf_contact_resident: "É o contacto indicado para {name}.",
  al_tab_care: "Cuidados",
  al_tab_maint: "Manutenção",
  al_maint_hint: "Sensores que deixaram de comunicar e baterias fracas: trabalho técnico, não eventos de cuidado.",
  al_maint_empty: "Nenhum problema de sensores ou baterias.",
  al_auto_closed: "Fechado automaticamente",
  al_auto_closed_reason: "Fechado automaticamente — {reason}",
  al_never_seen: "ninguém o viu antes de fechar",
  al_resolved_by: "Resolvido por {name}",
  al_reason_movement: "o movimento foi retomado",
  al_reason_sensor: "o sensor voltou a comunicar",
  al_admin_only_ack: "Só um administrador pode tratar este alerta, porque não está ligado a um único residente.",
  why_title: "Porque disparou?",
  why_since_motion: "Desde o último movimento",
  why_since_sample: "Desde a última comunicação do sensor",
  why_threshold: "Limite",
  why_up_by: "Normalmente levantado às",
  why_night: "Período noturno",
  why_source: "Limite definido por",
  why_src_org: "esta organização",
  why_src_default: "valores predefinidos",
  why_state: "Estado do sensor",
  why_checked: "Verificado às",
  why_approx: "As verificações correm a cada 5 minutos, por isso as horas dos alertas são aproximadas.",
  mon_label: "Acompanhamento do movimento",
  mon_active: "ativo",
  mon_down: "sem comunicar",
  mon_down_since: "sem comunicar desde as {time}",
  admin_alerts_up_by_label: "Normalmente levantado às",
  admin_alerts_up_by_question: "Se não houver movimento entre o fim da noite e esta hora, é criado um alerta «nenhum movimento desde o fim da noite».",
  admin_alerts_up_by_invalid: "Tem de ser depois do fim da noite ({end}): é a hora a que os residentes costumam estar levantados, já depois da noite.",
  admin_alerts_up_by_format: "Introduza uma hora como HH:MM.",
  admin_alerts_escalation_label: "Avisar a família de um sensor sem sinal após",
  admin_alerts_escalation_question: "A equipa vê logo um sensor sem sinal. A família só é avisada se continuar por resolver após este tempo (de imediato se a organização não tiver cuidadores).",
  admin_alerts_cooldown_note: "Depois de um alerta fechar, o mesmo alerta pode voltar quando o limite for de novo ultrapassado. O alerta da manhã dispara no máximo uma vez por dia.",
  admin_alerts_stored_invalid: "A hora guardada ({up}) não é depois do fim da noite ({end}), por isso os alertas da manhã não podem funcionar e esta política não pode ser guardada até ser corrigida.",
  admin_alerts_defaults_badge: "Valores predefinidos",

  fap_auto_on: "Automático: ativo, porque esta organização não tem cuidadores.",
  fap_auto_off: "Automático: inativo, porque esta organização tem cuidadores.",
  fap_manual: "Definido por um administrador.",
  fap_reset: "Voltar ao automático",
  fap_saved: "Guardado",
  fap_save_failed: "Não foi possível guardar. Tente novamente.",
  fap_pending: "Em breve",
  fap_retry: "Tentar novamente",
  recap_title: "Resumo matinal da noite",
  recap_desc_staff: "Todos os dias às 07:00 (hora da organização), um resumo da noite de cada residente da sua organização.",
  recap_desc_family: "Todos os dias às 07:00 (hora da organização), um resumo da noite dos seus entes queridos.",
  recap_on: "Ativado",
  recap_off: "Desativado",
  recap_email: "Email",
  recap_telegram_link_first: "Ligue o Telegram acima para o receber lá.",
  recap_no_channel: "Escolha pelo menos um canal, ou nada será enviado.",
  recap_last_sent: "Último envio {at}",
  recap_saved: "Preferências guardadas.",
  recap_save_failed: "Não foi possível guardar as preferências.",
  recap_unavailable: "Em breve",
  topbar_org_label: "Organização",
  device_ota_phase2: "A implementação OTA ficará interativa na fase 2.",
  event_window_open: "Janela aberta",
  event_window_close: "Janela fechada",
  event_alarm_end: "Fim do alarme",
  wt_h: "h",
  wt_load_failed: "Não foi possível carregar o histórico de movimento. Tente mais tarde.",
  recap_load_failed: "Não foi possível carregar as preferências — toque para tentar de novo.",
  mv_shared_note: "Este residente partilha o quarto. Um sensor de quarto não distingue residentes, por isso o movimento é mostrado para o quarto, não para uma pessoa.",
  mv_shared_link: "Ver o movimento de {room}",
  mv_room_shared_note: "Partilhado por {n} residentes — este movimento não pode ser atribuído a nenhum deles.",
  rep_shared_room_row: "Quarto partilhado · {names}",
  admin_motion_resident: "Sensor de cabeceira de um residente",
  admin_motion_resident_hint: "Opcional. Escolha um residente apenas se este sensor vigia o seu espaço pessoal (p. ex. virado para a cama). Os gráficos de movimento dele vão usá-lo, mesmo num quarto partilhado.",
  admin_motion_whole_room: "Quarto inteiro",
};
export default pt;
